import angular from 'angular';
import uiRouter from 'angular-ui-router';
import routing from './speechprofilees.routes';
import addHtml from './modal/add.html';
import _ from 'lodash';


export class SpeechProfileEsController {
    $http;
    socket;
    awesomeThings = [];
    speechProfile = [];
    newThing = '';

    /*@ngInject*/
    constructor($http, $scope, socket, $uibModal, $cookies, $cookieStore, $location) {
        this.$http = $http;
        this.socket = socket;
        this.$uibModal = $uibModal;
        this.$cookies = $cookies;
        this.$cookieStore = $cookieStore;
        this.$location = $location;
    }

    $onInit() {

        if (this.$cookies.get('token')) {


            this.$http.get('/api/speech_type_es/', {
                header: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'token': this.$cookies.get('token')
                }
            })
                .then(response => {
                    if (response.data.data) {
                        this.speechTypeName = response.data.data;
                    }
                });

            this.getTypeName = function (id) {
                console.log(id);
                let _name = _.find(this.speechTypeName, { speech_type_id: id });
                return _name.speech_type_name;
            }

            this.$http.get('/api/speech_profile_es/1/2/3/', {
                header: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'token': this.$cookies.get('token')
                },
                params: {
                    'page': 0,
                    'size': 20
                }
            })
                .then(response => {
                    if (response.data.data) {


                        this.maxSize = 20;
                        this.totalCount = response.data.count;
                        this.totalItems = response.data.count / 2;
                        this.currentPage = 1;

                        this.speechProfile = response.data.data;
                        this.socket.syncUpdates('speechProfile', this.speechProfile);
                    }

                });

        } else {
            this.$location.path('main')
        }
    }

    search(val) {
        if (val === true) {
            this.currentPage = 1;
        }
        const payload = angular.copy(this.filters);



        const ret = {
            filters: payload || {},
            page: this.currentPage - 1,
            size: 20
        };
        if (this.$cookies.get('token')) {

            this.$http.get('/api/speech_profile_es/1/2/3/', {
                header: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'token': this.$cookies.get('token')
                },
                params: ret
            })
                .then(response => {
                    if (response.data.data) {
                        this.maxSize = 20;
                        this.totalCount = response.data.count;
                        this.totalItems = response.data.count / 2;
                        this.speechProfile = response.data.data;
                        this.socket.syncUpdates('speechProfile', this.speechProfile);
                    }
                });
        } else {
            this.$location.path('main')
        }
    }

    addSpeechProfile() {
        const speechProfile = this.speechProfile;

        this.$uibModal.open({
            template: addHtml,
            size: 'lg',
            /*@ngInject*/
            controller: function ($scope, $http, $uibModalInstance, $cookies, FileUploader) {
                $scope.vm = {};

                $scope.isload = false;
                $scope.isloadcover = false;
                $scope.isloadcoversmall = false;

                let uploader = $scope.uploader = new FileUploader({
                    url: '/api/speech_profiles/9527/',
                    method: 'POST',
                    autoUpload: true,
                });

                let uploader1 = $scope.uploaderImage = new FileUploader({
                    url: '/api/speech_profiles/9528/',
                    method: 'POST',
                    autoUpload: true,
                });

                let uploader2 = $scope.uploaderImageSmall = new FileUploader({
                    url: '/api/speech_profiles/9529/',
                    method: 'POST',
                    autoUpload: true,
                });


                uploader.filters.push({
                    name: 'Filter',
                    fn: function (item, options) {
                        console.log(item);
                        if (item.type.indexOf('mp3') !== -1 || item.type.indexOf('wav') !== -1) {
                            $scope.isload = true;
                            $scope.isloadSpeechUrlError = false;
                            let s = item.name.split('.');
                            $scope.vm.speech_name = s[0];
                            return true;
                        } else {
                            console.log('请选择正确的文件格式!', 'ERROR!');
                            $scope.isloadSpeechUrlError = true;
                            return false;
                        }

                    }
                });


                uploader1.filters.push({
                    name: 'Filter',
                    fn: function (item, options) {
                        if (item.type.indexOf('image') !== -1) {
                            $scope.isloadcover = true;
                            $scope.isloadcoverError = false;
                            return true;
                        } else {
                            console.log('请选择正确的文件格式!', 'ERROR!');
                            $scope.isloadcoverError = true;

                            return false;
                        }

                    }
                });

                uploader2.filters.push({
                    name: 'Filter',
                    fn: function (item, options) {
                        if (item.type.indexOf('image') !== -1) {
                            $scope.isloadcoversmall = true;
                            $scope.isloadcoversmallError = false;
                            return true;
                        } else {
                            $scope.isloadcoversmallError = true;
                            console.log('请选择正确的文件格式!', 'ERROR!');
                            return false;
                        }

                    }
                });

                uploader.onSuccessItem = function (fileItem, response, status, headers) {
                    if (status === 200) {
                        console.log('上传成功!', 'SUCCESS!');
                        $scope.isload = false;
                        $scope.vm.speech_url = response.data.speech_url;
                        $scope.vm.speech_size = response.data.speech_size;
                        // $scope.vm.speech_during = response.data.speech_during;
                    }
                };

                $scope.clearItems = function () {
                    uploader.clearQueue();
                }

                uploader1.onSuccessItem = function (fileItem, response, status, headers) {
                    if (status === 200) {
                        console.log('上传成功!', 'SUCCESS!');
                        $scope.isloadcover = false;
                        $scope.vm.cover_img = response.data.cover_img;

                    }
                };

                $scope.clearItems1 = function () {
                    uploader1.clearQueue();
                }

                uploader2.onSuccessItem = function (fileItem, response, status, headers) {
                    if (status === 200) {
                        console.log('上传成功!', 'SUCCESS!');
                        $scope.isloadcoversmall = false;
                        $scope.vm.cover_small_img = response.data.cover_small_img;

                    }
                };

                $scope.clearItems2 = function () {
                    uploader2.clearQueue();
                }



                $http.get('/api/speech_type_es/', {
                    header: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'token': $cookies.get('token')
                    }
                })
                    .then(response => {
                        if (response.data.data) {
                            $scope.speechTypes = response.data.data;
                        }
                    });


                $scope.changeType = function (index) {

                    if (index === 1) {
                        $scope.isType_one = true;
                        $scope.isType_two = false;
                    }

                    if (index !== 1) {
                        $scope.isType_two = true;
                        $scope.isType_one = false;
                    }
                }



                $scope.save = function (myForm) {
                    console.log($scope.vm.profile);
                    if (myForm.$valid === false && $scope.isload === false) {
                        return false;
                    } else {
                        let ret = {};
                        if ($scope.vm.speech_type_id === 1) {
                            ret['speech_type_id'] = $scope.vm.speech_type_id;
                            ret['speech_name'] = $scope.vm.speech_name;
                            ret['cover_img'] = $scope.vm.cover_img;
                            ret['cover_small_img'] = $scope.vm.cover_small_img;
                            ret['speech_url'] = $scope.vm.speech_url;
                            ret['desc'] = $scope.vm.desc;
                            ret['speech_size'] = $scope.vm.speech_size;
                            ret['speech_during'] = $scope.vm.speech_during;
                        }
                        if ($scope.vm.speech_type_id !== 1) {
                            ret['speech_type_id'] = $scope.vm.speech_type_id;
                            ret['speech_name'] = $scope.vm.speech_name;
                            ret['cover_img'] = $scope.vm.cover_img;
                            ret['desc'] = $scope.vm.desc;
                            ret['profile'] = $scope.vm.profile;
                        }
                        console.log(ret);
                        $http.post('/api/speech_profile_es/', ret).then((response) => {
                            console.log(response.data.data);
                            $uibModalInstance.close(response.data.data);
                        }, (error) => {
                            console.log(error);
                        });
                    }
                };
                $scope.cancel = function () {
                    $uibModalInstance.close();
                };
            }
        })
            .result.then(function (data) {
                if (data) {
                    speechProfile.push(data);
                }
            }, function () {
            });
    }


    editSpeechProfile(type, index) {
        const speechProfile = this.speechProfile;
        this.$uibModal.open({
            template: addHtml,
            size: 'lg',
            /*@ngInject*/
            controller: function ($scope, $http, $uibModalInstance, $cookies, FileUploader) {
                console.log(type);
                $scope.vm = angular.copy(type);


                $http.get('/api/speech_type_es/', {
                    header: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'token': $cookies.get('token')
                    }
                })
                    .then(response => {
                        if (response.data.data) {
                            $scope.speechTypes = response.data.data;
                        }
                    });

                if ($scope.vm.speech_type_id === 1) {
                    $scope.isType_one = true;
                    $scope.isType_two = false;
                }
                if ($scope.vm.speech_type_id !== 1) {
                    $scope.isType_two = true;
                    $scope.isType_one = false;
                }

                $scope.changeType = function (index) {

                    if (index === 1) {
                        $scope.isType_one = true;
                        $scope.isType_two = false;
                    }

                    if (index !== 1) {
                        $scope.isType_two = true;
                        $scope.isType_one = false;
                    }
                }

                $scope.isload = false;
                $scope.isloadcover = false;
                $scope.isloadcoversmall = false;

                let uploader = $scope.uploader = new FileUploader({
                    url: '/api/speech_profiles/9527/',
                    method: 'POST',
                    autoUpload: true,
                });

                let uploader1 = $scope.uploaderImage = new FileUploader({
                    url: '/api/speech_profiles/9528/',
                    method: 'POST',
                    autoUpload: true,
                });

                let uploader2 = $scope.uploaderImageSmall = new FileUploader({
                    url: '/api/speech_profiles/9529/',
                    method: 'POST',
                    autoUpload: true,
                });


                uploader.filters.push({
                    name: 'Filter',
                    fn: function (item, options) {
                        console.log(item);
                        if (item.type.indexOf('mp3') !== -1 || item.type.indexOf('wav') !== -1) {
                            $scope.isload = true;
                            $scope.isloadSpeechUrlError = false;
                            let s = item.name.split('.');
                            $scope.vm.speech_name = s[0];
                            return true;
                        } else {
                            console.log('请选择正确的文件格式!', 'ERROR!');
                            $scope.isloadSpeechUrlError = true;
                            return false;
                        }

                    }
                });


                uploader1.filters.push({
                    name: 'Filter',
                    fn: function (item, options) {
                        if (item.type.indexOf('image') !== -1) {
                            $scope.isloadcover = true;
                            $scope.isloadcoverError = false;
                            return true;
                        } else {
                            console.log('请选择正确的文件格式!', 'ERROR!');
                            $scope.isloadcoverError = true;

                            return false;
                        }

                    }
                });

                uploader2.filters.push({
                    name: 'Filter',
                    fn: function (item, options) {
                        if (item.type.indexOf('image') !== -1) {
                            $scope.isloadcoversmall = true;
                            $scope.isloadcoversmallError = false;
                            return true;
                        } else {
                            $scope.isloadcoversmallError = true;
                            console.log('请选择正确的文件格式!', 'ERROR!');
                            return false;
                        }

                    }
                });

                uploader.onSuccessItem = function (fileItem, response, status, headers) {
                    if (status === 200) {
                        console.log('上传成功!', 'SUCCESS!');
                        $scope.isload = false;
                        $scope.vm.speech_url = response.data.speech_url;
                        $scope.vm.speech_size = response.data.speech_size;
                        // $scope.vm.speech_during = response.data.speech_during;
                    }
                };

                $scope.clearItems = function () {
                    uploader.clearQueue();
                }

                uploader1.onSuccessItem = function (fileItem, response, status, headers) {
                    if (status === 200) {
                        console.log('上传成功!', 'SUCCESS!');
                        $scope.isloadcover = false;
                        $scope.vm.cover_img = response.data.cover_img;

                    }
                };

                $scope.clearItems1 = function () {
                    uploader1.clearQueue();
                }

                uploader2.onSuccessItem = function (fileItem, response, status, headers) {
                    if (status === 200) {
                        console.log('上传成功!', 'SUCCESS!');
                        $scope.isloadcoversmall = false;
                        $scope.vm.cover_small_img = response.data.cover_small_img;

                    }
                };

                $scope.clearItems2 = function () {
                    uploader2.clearQueue();
                }




                $scope.save = function (myForm) {
                    if (myForm.$valid === false) {
                        return false;
                    } else {
                        console.log($scope.vm);
                        $http.put('/api/speech_profile_es/' + type.speech_profile_id + '/', $scope.vm).then((response) => {
                            console.log(response);
                            $uibModalInstance.close(response.data.data);
                        }, (error) => {
                            console.log(error);
                        });
                    }
                };
                $scope.cancel = function () {
                    $uibModalInstance.close();
                };
            }
        })
            .result.then(function (ret) {
                if (ret) {
                    speechProfile[index] = ret;
                }
            }, function () {
            });
    }



    deleteSpeechProfile(type, index) {
        this.$http.delete('/api/speech_profile_es/' + type.speech_profile_id + '/').then(response => {
            if (response.status === 200) {
                this.speechProfile.splice(index, 1)
            }
        }, error => {
            console.log(error);
        });
    }
}

export default angular.module('tttApp.speechprofilees', [uiRouter])
    .config(routing)
    .component('speechprofilees', {
        template: require('./speechprofilees.html'),
        controller: SpeechProfileEsController
    })
    .name;



// WEBPACK FOOTER //
// ./client/app/speechprofilees/speechprofilees.component.js